import React from 'react';

const AdminDashboardPage = () => {
  return (
    <div className="card p-4 rounded-lg shadow-md">
      <h2 className="page-title heading-primary-1 text-2xl font-bold mb-4">Admin Dashboard</h2>
      <p className="text-muted">Use the Manage route to edit user data.</p>
    </div>
  );
};

export default AdminDashboardPage;
